export const TIPO_CONCURSO_DECLARACION_MODELO = {
  PRECONCURSAL: 1,
  POSTCONCURSAL: 2,
} as const

export type TipoConcursoDeclaracionModeloEnumType =
  (typeof TIPO_CONCURSO_DECLARACION_MODELO)[keyof typeof TIPO_CONCURSO_DECLARACION_MODELO]
